export default {
      id: "info-circle-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#info-circle",
      toString: function () {
        return this.url;
      }
    }